import { Link, useLocation } from "react-router-dom";

const TABS = [
  { key: "live", label: "실시간", to: "/" },
  { key: "history", label: "이력", to: "/history" },
  { key: "camera", label: "카메라 화각", to: "/camera" },
] as const;

/**
 * 공용 페이지 탭 — 실시간 / 이력 / 카메라 화각. 모든 라우트에서 동일하게 렌더한다.
 * 활성 탭은 현재 경로로 판정: "/history"·"/camera" 는 접두 매칭, 그 외(루트)는 실시간.
 */
export default function PageTabs() {
  const { pathname } = useLocation();
  const activeKey = pathname.startsWith("/history")
    ? "history"
    : pathname.startsWith("/camera")
      ? "camera"
      : "live";

  return (
    <div className="mb-6 flex gap-1 border-b border-surface-border dark:border-surface-darkBorder">
      {TABS.map((t) => {
        const active = t.key === activeKey;
        return (
          <Link
            key={t.key}
            to={t.to}
            className={
              // 모바일 44px(py-3 + line-height) — 탭은 페이지 전환의 주 동선이라 특히 중요.
              "relative -mb-px inline-flex min-h-[2.75rem] items-center px-4 py-3 text-sm font-medium transition-colors sm:min-h-0 sm:py-2 " +
              (active
                ? "border-b-2 border-slate-800 text-slate-900 dark:border-slate-100 dark:text-slate-100"
                : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200")
            }
          >
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}
